import { PdsWidget } from '../../pds-widget';
import { DateFilter } from '../../models/grid-widget/date-filter';
import { pdsUtils } from '../../pds-utils';
import { pdsLogger } from '../../pds-logger';
import { pdsI18n } from '../../pds-i18n';
import {DateField} from '../../models/grid-widget/date-field';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('gridWidget'), 'pds-gw-date-filter.ts');

let filterComparators;

export class PdsGwDateFilter extends PdsWidget {
  is = 'pds-gw-date-filter';
  name: string;

  id: string;

  filter: DateFilter;

  attached(): void {
    log('attached called');
    super.attached();
    this.watch('filter.comparator');

    let container: HTMLElement | null = this.querySelector('.pds-gw-date-filter-content');
    if (container != null) {
      container.addEventListener('modelValueChange', (event: Event) => {
        if (pdsUtils.is(event.target as HTMLElement, 'pds-date-widget[name$="-1"]')) {
          this.filter.searchValueDate = (event.target as any).modelValue;
        } else {
          this.filter.searchValueDate2 = (event.target as any).modelValue;
        }
        this.inputChange();
      });
    }
  }

  inputChange(): void {
    log('inputChange called');
    this.filter.comparator = this.querySelector('select').value;
    // this.filter = this.filter;
    let event: Event = new Event('renderedElementValueChange', {bubbles: true});
    this.dispatchEvent(event);
  }

  getDateField(): DateField {
    log('getNumberField called');
    return <DateField>this.filter.dataField;
  }

  getDateFilterComparators(): Array<{ value: string, text: string }> {
      if (filterComparators == null) {
      filterComparators = [
        {
          value: '>=',
          text: '≥'
        },
        {
          value: '>',
          text: '>'
        },
        {
          value: '=',
          text: '='
        },
        {
          value: '<',
          text: '<'
        },
        {
          value: '<=',
          text: '≤'
        },
        {
          value: 'range',
          text: pdsI18n.getText('pds|grid widget|Range')
        }
      ];
    }
      return filterComparators;
  }

  getLabelText(): string {
    return this.filter.comparator === 'range' ? 'Above' : this.filter.dataField.title;
  }

  getPlaceholderText(): string {
    if (this.filter == null || this.filter.dataField == null) {
      return '';
    }
    return this.getDateField().placeholderText;
  }

  getValidationRule(attributeName: string): string | null {
    log('getValidationRule called');
    if (this.filter != null &&
      this.filter.dataField != null &&
      this.filter.dataField.validationRules != null) {
      return this.filter.dataField.validationRules[attributeName];
    }
    return null;
  }
}
